import { Button, Input } from '@insify/design-system/components';
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { isProd } from '../env';
import { useAuthStore } from '../stores/authStore';

import type React from 'react';

const HARDCODED_PASSWORD = 'hi-carmi';
const AUTH_KEY = 'public-route-auth';

const PublicRoute: React.FC = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const setIsAuthComplete = useAuthStore((state) => state.setIsAuthComplete);

  useEffect(() => {
    const authToken = localStorage.getItem(AUTH_KEY);
    setIsAuthComplete(true);
    if (authToken === 'authenticated') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Submitted password:', password);
    if (password === HARDCODED_PASSWORD) {
      localStorage.setItem(AUTH_KEY, 'authenticated');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Invalid password');
    }
  };

  if (isProd) {
    return <Navigate to='/' replace />;
  }

  if (isAuthenticated) {
    return <Outlet />;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '20px',
        maxWidth: '400px',
        margin: '50px auto',
        background: 'var(--putty-50, #F8F5F2)',
      }}
    >
      <h2>Access Required</h2>
      <form onSubmit={handleSubmit}>
        <Input
          name='password'
          type='password'
          placeholder='Enter password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
          hasNoBottomContent
        />
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        <Button kind='primary' trackingId='public-route-submit' type='submit' style={{ width: '100%' }}>
          Submit
        </Button>
      </form>
    </div>
  );
};

export { PublicRoute };
